export default "__VITE_ASSET__BVdHCSJ7__"